import { render, staticRenderFns } from "./departEdit.vue?vue&type=template&id=fa5c5e8a&scoped=true"
import script from "./departEdit.vue?vue&type=script&lang=js"
export * from "./departEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5c5e8a",
  null
  
)

export default component.exports